class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            inputCountry: this.querySelector('input[name="country_code"]'),
            inputLanguage: this.querySelector('input[name="locale_code"]'),
            button: this.querySelector('button'),
            form: this.querySelector('form'),
            panel: this.querySelector('.disclosure__list-wrapper'),
        };

        this.form = this.querySelector('form');
        this.country = this.querySelector('[name="country_code"]');
        this.language = this.querySelector('[name="locale_code"]');

        this.geoWrapper = this.querySelector('[data-geo-wrapper]');

        this.backButton = this.querySelector('[data-back]');

    }

    connectedCallback() {
        this.form?.addEventListener('submit', (event) => {
            this.onSubmit(event);
        });

        this.checkCountry();
    }

    async checkCountry() {
        if (this.getCookie('forceLocalization')) return

        const url = `/browsing_context_suggestions.json`
            + `?country[enabled]=true`
            + `&country[exclude]=${window.Shopify.country}`
            + `&language[enabled]=true`
            + `&language[exclude]=${window.Shopify.locale}`;
        const result = await (await fetch(url)).json();

        const navigationCountry = result.detected_values.country
        if (navigationCountry.handle === this.dataset.userCountry)
            return;


        result.suggestions.forEach((suggestion, index) => {
            if (suggestion.parts.country && suggestion.parts.country.confidence < 2) {
                this.country.value = suggestion.parts.country.handle;
            }
            if (suggestion.parts.language && suggestion.parts.language.confidence < 2) {
                this.language.value = suggestion.parts.language.handle;
            }
        });

        const countrySpan = this.querySelector('[data-country]');
        countrySpan.innerText = navigationCountry.name;

        this.geoWrapper.removeAttribute('hidden');
        this.backButton.removeAttribute('hidden');

        this.backButton?.addEventListener('click', () => {
            this.setCookie('forceLocalization', true);
            this.closest('dialog').close();
        });

        publish(PUB_SUB_EVENTS.countryPopupOpen);
    }

    onSubmit(event) {
        event.preventDefault();

        this.setCookie('forceLocalization', true);
        this.form.submit();

    }

    setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${encodeURIComponent(
            value
        )};expires=${date.toUTCString()};path=/`;
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2)
            return decodeURIComponent(parts.pop().split(";").shift());
        return null;
    }

}
customElements.define('localization-form', LocalizationForm);